
import { Alert, Button, Form, Icon, Input, Spin } from 'antd';
import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { saveLogin } from '../auth/localStorage';
import styles from './login.css';
import { login } from './loginActions';

const FormItem = Form.Item;

class LoginComponent extends Component {

  submit = (e) => {
    e.preventDefault();

    const { dispatch } = this.props;
    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }
      const {username, password} = this.props.form.getFieldsValue();
      dispatch(login(username, password));
    });
  }

  render() {
    let user = this.props.user;
    const { getFieldDecorator } = this.props.form;
    
    if (user) {
      let loginFailed = user.status !== 'success';

      if (!loginFailed) {
        saveLogin({user});
        return <Redirect to="/rattsfall"/>;
      }
    }

    return (
      <div style={styles.loginForm}>

        <img src='/logo.jpg' style={styles.logo} alt={'infosoc.se'}/>

        {this.props.error? <Alert
          message="Inloggningen misslyckades"
          type="error"
          style={{marginBottom: 20}}
        /> : ''}


        <Form onSubmit={this.submit} >
          <FormItem>
            {getFieldDecorator('username', { rules: [{ required: true, message: 'Ange din e-postadress' }] })(
              <Input prefix={<Icon type="user" style={styles.inputIcon} />} placeholder="Användarnamn" />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('password', { rules: [{ required: true, message: 'Ange ditt lösenord' }] })(
              <Input prefix={<Icon type="lock" style={styles.inputIcon} />} type="password" placeholder="Lösenord" />
            )}
          </FormItem>
          
          <Spin spinning={this.props.loading}>
            <Button type="primary" size={'large'} htmlType="submit" style={{width: '100%', backgroundColor: '#009CCA'}}>Logga in</Button>
           </Spin>
        </Form>
        
      </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.login.user,
    loading: state.login.loading,
    error: state.login.error
  }
};

const LoginComponentForm = Form.create()(LoginComponent);
export default connect(mapStateToProps)(withRouter(LoginComponentForm));


// WEBPACK FOOTER //
// ./src/login/loginComponent.js